export const SHELL_COMPANY_EVENT = "suite:company-selection";

export function announceShellCompany(name, id = "") {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(SHELL_COMPANY_EVENT, {
    detail: { id, name: name || "" },
  }));
}

export function companyNameForShell(companies, companyId, fallback = "Tutte le aziende") {
  if (!companyId) return fallback;
  return companies.find((company) => company.id === companyId)?.name || fallback;
}
